import {CommonService} from "../../shared/services";
import {call, put, takeEvery} from 'redux-saga/effects'
import {
    GET_ACCOUNT_EXECUTIVE_LIST,
    GET_ACCOUNT_PREFERENCES,
    GET_BILLING_MODE_LIST,
    GET_CITY_LIST_LITE,
    GET_ETHNICITY_LIST,
    GET_FACILITY_LIST_LITE,
    GET_FACILITY_STATUS,
    GET_FACILITY_TYPES,
    GET_INSURANCE_COMPANY_LIST,
    GET_INSURANCE_PLAN_LIST,
    GET_LAB_LIST_LITE,
    GET_REPORT_TYPE_LIST,
    GET_LAB_STATUS,
    GET_LOCATION_LIST_LITE,
    GET_LOCATION_STATUS,
    GET_PANEL_CODE_LIST,
    GET_PAYOR_MIX_LIST,
    GET_PHYSICIAN_LIST_LITE,
    GET_RACE_LIST,
    GET_RELATION_SHIP_LIST,
    GET_SAMPLE_STATUS_LIST,
    GET_SAMPLE_TYPES_LIST,
    GET_TEST_ORDER_STATUS,
    GET_TEST_PANEL_STATUS,
    GET_USER_LIST,
    GET_TEST_PANEL_LIST,
    GET_ALL_LOCATION_LIST_LITE,
    GET_EQUIPMENT_TYPE_LIST,
    GET_SAMPLE_COLLECTION_DEVICE_LIST,
    GET_TEST_LIST_LITE,
    GET_EXPRESSIONS_LIST_LITE,
    GET_BIOMARKER_LIST,
    GET_AGE_LIST,
    GET_ROLE_LIST,
    setSampleCollectionDeviceData,
    setAccountExecutiveList,
    setAccountPreferenceStaticData,
    setBillingModeList,
    setCityListLite,
    setEthnicityData,
    setFacilityListLite,
    setFacilityStatus,
    setFacilityTypes,
    setInsuranceCompanyData,
    setInsurancePlanData,
    setLabListLite,
    setLabStatus,
    setLocationListLite,
    setAllLocationListLite,
    setLocationStatus,
    setPanelCodeList,
    setPayorMixList,
    setPhysicianListLite,
    setRaceData,
    setRelationshipData,
    setSampleStatusList,
    setSampleTypesList,
    setTestOrderStatus,
    setTestPanelStatus,
    setUserList,
    setEquipmentTypeList,
    setTestPanelList,
    setReportTypeData,
    setTestListLite,
    setExpressionsListLite,
    setBiomarkerList,
    setAgeList,
    setRoleList,
    GET_SYSTEM_CONFIG,
    setSystemConfig,
    GET_SAMPLE_TYPES_WITH_COLLECTION_DEVICES,
    setSampleTypesWithCollectionDevices,
    GET_PREFIX_LIST,
    GET_SUFFIX_LIST,
    GET_MARITAL_STATUS_LIST,
    setPrefixList,
    setSuffixList,
    setMaritalStatusList, GET_MODULE_PRIMARY_ATTACHMENT, setModulePrimaryAttachment
} from "../actions/staticData.action";
import commonService from "../../shared/services/common.service";

const fetchInsuranceCompanyList = () => {
    return CommonService._staticData.getInsuranceCompanyList({});
};

const fetchInsurancePolicyList = () => {
    return CommonService._staticData.getInsuranceCompanyList({});
};

const fetchRelationshipList = () => {
    return CommonService._staticData.getRelationshipList({});
};

const fetchEthnicityList = () => {
    return CommonService._staticData.getEthnicityList({});
};

const fetchRaceList = () => {
    return CommonService._staticData.getRaceList({});
};

const fetchFacilityTypesList = () => {
    return CommonService._staticData.getFacilityTypesList({});
};

const fetchUserList = () => {
    return CommonService._staticData.getUserList({});
};

const fetchPayorMixList = () => {
    return CommonService._staticData.getPayorMixList({});
};

const fetchAccountPreferences = () => {
    return CommonService._staticData.getAccountPreferencesSettingsStaticData({});
}

const fetchFacilityListLite = () => {
    return CommonService._facility.getFacilityListLite({isActive: true});
}

const fetchLocationListLite = () => {
    return CommonService._location.getLocationListLite({isActive: true});
}

const fetchAllLocationListLite = () => {
    return CommonService._location.getLocationListLite({});
}

const fetchLabsListLite = () => {
    return CommonService._lab.getLabListLite({isActive: true});
}

const fetchTestOrderStatus = () => {
    return CommonService._staticData.getTestOrderStatus({});
}

const fetchTestPanelStatus = () => {
    return CommonService._staticData.getTestPanelStatus({});
}

const fetchLabStatus = () => {
    return CommonService._staticData.getLabStatus({});
}

const fetchFacilityStatus = () => {
    return CommonService._staticData.getFacilityStatus({});
}

const fetchLocationStatus = () => {
    return CommonService._staticData.getLocationStatus({});
}

const fetchPhysicianListLite = () => {
    return CommonService._staticData.getPhysicianListLite({});
}

const fetchCityListLite = () => {
    return CommonService._staticData.getCityListLite({});
}

const fetchSuffixList = () => {
    return CommonService._staticData.getSuffixList({});
}

const fetchPrefixList = () => {
    return CommonService._staticData.getPrefixList({});
}

const fetchMaritalStatusList = () => {
    return CommonService._staticData.getMaritalStatusList({});
}

const fetchSampleStatusList = () => {
    return CommonService._staticData.getSampleStatusList({});
}

const fetchSampleTypesList = () => {
    return CommonService._staticData.getSampleTypesList({});
}

const fetchBillingModeList = () => {
    return CommonService._staticData.getBillingModes({});
}

const fetchPanelCodeList = () => {
    return CommonService._staticData.getPanelCodeList({});
}


const fetchAccountExecutiveList = () => {
    return CommonService._staticData.getAccountExecutiveList({roleCode: 'accountExecutive'});
}

const fetchEquipmentTypeList = () => {
    return CommonService._staticData.getEquipmentTypeList({});
}
const fetchTestPanelList = () => {
    return CommonService._staticData.getTestPanelListLite({});
}

const fetchSampleCollectionDeviceList = () => {
    return CommonService._staticData.getSampleCollectionDeviceList({});
}

const fetchReortTypesList = () => {
    return CommonService._staticData.getReportTypesList({});
}

const fetchTestListLite = () => {
    return CommonService._staticData.getTestListLite({});
}

const fetchExpressionsListLite = () => {
    return CommonService._staticData.getExpressionsListLite({});
}

const fetchBiomarkerList = () => {
    return CommonService._test.getBiomarkerList("", "");
}

const fetchAgeList = () => {
    return CommonService._staticData.getAgeList({});
}

const fetchRoleList = () => {
    return CommonService._staticData.getRoleList({});
}
const fetchSystemConfig = () => {
    return commonService._staticData.getSystemConfig();
}
const fetchSampleTypesWithCollectionDevices = () => {
    return commonService._staticData.getSampleTypeWithCollectionDevicesApi()
}

const fetchModulePrimaryAttachment = () => {
    return commonService._staticData.getModulePrimaryAttachment();
}

function* getInsuranceCompanyList(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchInsuranceCompanyList);
        yield put(setInsuranceCompanyData(resp.data));
    } catch (error) {
        yield put(setInsuranceCompanyData([]));
    }
}

function* getInsurancePolicyList(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchInsurancePolicyList);
        yield put(setInsurancePlanData(resp.data));
    } catch (error) {
        yield put(setInsurancePlanData([]));
    }
}

function* getRelationshipList(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchRelationshipList);
        yield put(setRelationshipData(resp.data));
    } catch (error) {
        yield put(setRelationshipData([]));
    }
}

function* getEthnicityList(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchEthnicityList);
        yield put(setEthnicityData(resp.data));
    } catch (error) {
        yield put(setEthnicityData([]));
    }
}

function* getRaceList(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchRaceList);
        yield put(setRaceData(resp.data));
    } catch (error) {
        yield put(setRaceData([]));
    }
}

function* getFacilityTypesList(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchFacilityTypesList);
        yield put(setFacilityTypes(resp.data));
    } catch (error) {
        yield put(setFacilityTypes([]));
    }
}

function* getUserList(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchUserList);
        yield put(setUserList(resp.data));
    } catch (error) {
        yield put(setUserList([]));
    }
}

function* getPayorMixList(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchPayorMixList);
        yield put(setPayorMixList(resp.data));
    } catch (error) {
        yield put(setPayorMixList([]));
    }
}

function* getAccountPreferenceData(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchAccountPreferences);
        yield put(setAccountPreferenceStaticData(resp.data));
    } catch (error) {
        yield put(setAccountPreferenceStaticData([]));
    }
}

function* getFacilityListLiteData(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchFacilityListLite);
        yield put(setFacilityListLite(resp.data));
    } catch (error) {
        yield put(setFacilityListLite([]));
    }
}

function* getLocationListLiteData(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchLocationListLite);
        yield put(setLocationListLite(resp.data));
    } catch (error) {
        yield put(setLocationListLite([]));
    }
}

function* getAllLocationListLiteData(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchAllLocationListLite);
        yield put(setAllLocationListLite(resp.data));
    } catch (error) {
        yield put(setAllLocationListLite([]));
    }
}

function* getLabListLiteData(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchLabsListLite);
        yield put(setLabListLite(resp.data));
    } catch (error) {
        yield put(setLabListLite([]));
    }
}

function* getTestOrderStatus(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchTestOrderStatus);
        yield put(setTestOrderStatus(resp.data));
    } catch (error) {
        yield put(setTestOrderStatus([]));
    }
}

function* getTestPanelStatus(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchTestPanelStatus);
        yield put(setTestPanelStatus(resp.data));
    } catch (error) {
        yield put(setTestPanelStatus([]));
    }
}

function* getFacilityStatus(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchFacilityStatus);
        yield put(setFacilityStatus(resp.data));
    } catch (error) {
        yield put(setFacilityStatus([]));
    }
}

function* getLocationStatus(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchLocationStatus);
        yield put(setLocationStatus(resp.data));
    } catch (error) {
        yield put(setLocationStatus([]));
    }
}

function* getLabStatus(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchLabStatus);
        yield put(setLabStatus(resp.data));
    } catch (error) {
        yield put(setLabStatus([]));
    }
}

function* getPhysicianListLite(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchPhysicianListLite);
        yield put(setPhysicianListLite(resp.data));
    } catch (error) {
        yield put(setPhysicianListLite([]));
    }
}

function* getCitiesListLite(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchCityListLite);
        yield put(setCityListLite(resp.data));
    } catch (error) {
        yield put(setCityListLite([]));
    }
}

function* getSuffixList(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchSuffixList);
        yield put(setSuffixList(resp.data));
    } catch (error) {
        yield put(setSuffixList([]));
    }
}

function* getPrefixList(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchPrefixList);
        yield put(setPrefixList(resp.data));
    } catch (error) {
        yield put(setPrefixList([]));
    }
}

function* getMaritalStatusList(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchMaritalStatusList);
        yield put(setMaritalStatusList(resp.data));
    } catch (error) {
        yield put(setMaritalStatusList([]));
    }
}

function* getSampleStatusList(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchSampleStatusList);
        yield put(setSampleStatusList(resp.data));
    } catch (error) {
        yield put(setSampleStatusList([]));
    }
}

function* getSampleTypesList(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchSampleTypesList);
        yield put(setSampleTypesList(resp.data));
    } catch (error) {
        yield put(setSampleTypesList([]));
    }
}

function* getPanelCodeList(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchPanelCodeList);
        yield put(setPanelCodeList(resp.data));
    } catch (error) {
        yield put(setPanelCodeList([]));
    }
}

function* getBillingModeList(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchBillingModeList);
        yield put(setBillingModeList(resp.data));
    } catch (error) {
        yield put(setBillingModeList([]));
    }
}

function* getAccountExecutiveList(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchAccountExecutiveList);
        yield put(setAccountExecutiveList(resp.data));
    } catch (error) {
        yield put(setAccountExecutiveList([]));
    }
}

function* getEquipmentTypeList(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchEquipmentTypeList);
        yield put(setEquipmentTypeList(resp.data));

    } catch (error) {
        yield put(setEquipmentTypeList([]));
    }
}

function* getTestPanelList(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchTestPanelList);
        yield put(setTestPanelList(resp.data));

    } catch (error) {
        yield put(setTestPanelList([]));
    }
}

function* getSampleCollectionDeviceList(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchSampleCollectionDeviceList);
        yield put(setSampleCollectionDeviceData(resp.data));
    } catch (error) {
        yield put(setSampleCollectionDeviceData([]));
    }
}

function* getReportTypesList(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchReortTypesList);
        yield put(setReportTypeData(resp.data));
    } catch (error) {
        yield put(setReportTypeData([]));
    }
}

function* getTestListLite(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchTestListLite);
        yield put(setTestListLite(resp.data));
    } catch (error) {
        yield put(setTestListLite([]));
    }
}

function* getExpressionsListLite(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchExpressionsListLite);
        yield put(setExpressionsListLite(resp.data));
    } catch (error) {
        yield put(setExpressionsListLite([]));
    }
}

function* getBiomarkerList(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchBiomarkerList);
        yield put(setBiomarkerList(resp.data));
    } catch (error) {
        yield put(setBiomarkerList([]));
    }
}

function* getAgeList(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchAgeList);
        yield put(setAgeList(resp.data));

    } catch (error) {
        yield put(setAgeList([]));
    }
}

function* getRoleList(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchRoleList);
        yield put(setRoleList(resp.data));


    } catch (error) {
        yield put(setRoleList([]));
    }
}

function* getSystemConfig(action: any) {
    try {
// @ts-ignore
        const resp = yield call(fetchSystemConfig);
        yield put(setSystemConfig(resp.data));


    } catch (error) {
        yield put(setSystemConfig([]));
    }
}

function* getSampleTypesWithCollectionDevices() {
    try {
        // @ts-ignore
        const resp = yield call(fetchSampleTypesWithCollectionDevices);
        yield put(setSampleTypesWithCollectionDevices(resp.data || []));
    } catch (error) {
        yield put(setSampleTypesWithCollectionDevices([]));
    }
}

function* getModulePrimaryAttachment() {
    try {
        // @ts-ignore
        const resp = yield call(fetchModulePrimaryAttachment);
        yield put(setModulePrimaryAttachment(resp.data || {}));
    } catch (error) {
        yield put(setModulePrimaryAttachment({}));
    }
}

export default function* StaticDataSaga() {
    yield takeEvery(GET_INSURANCE_COMPANY_LIST, getInsuranceCompanyList);
    yield takeEvery(GET_INSURANCE_PLAN_LIST, getInsurancePolicyList);
    yield takeEvery(GET_RELATION_SHIP_LIST, getRelationshipList);
    yield takeEvery(GET_ETHNICITY_LIST, getEthnicityList);
    yield takeEvery(GET_RACE_LIST, getRaceList);
    yield takeEvery(GET_FACILITY_TYPES, getFacilityTypesList);
    yield takeEvery(GET_USER_LIST, getUserList);
    yield takeEvery(GET_PAYOR_MIX_LIST, getPayorMixList);
    yield takeEvery(GET_ACCOUNT_PREFERENCES, getAccountPreferenceData);
    yield takeEvery(GET_FACILITY_LIST_LITE, getFacilityListLiteData);
    yield takeEvery(GET_LOCATION_LIST_LITE, getLocationListLiteData);
    yield takeEvery(GET_ALL_LOCATION_LIST_LITE, getAllLocationListLiteData);
    yield takeEvery(GET_LAB_LIST_LITE, getLabListLiteData);
    yield takeEvery(GET_PHYSICIAN_LIST_LITE, getPhysicianListLite);
    yield takeEvery(GET_LAB_STATUS, getLabStatus);
    yield takeEvery(GET_TEST_ORDER_STATUS, getTestOrderStatus);
    yield takeEvery(GET_TEST_PANEL_STATUS, getTestPanelStatus);
    yield takeEvery(GET_FACILITY_STATUS, getFacilityStatus);
    yield takeEvery(GET_LOCATION_STATUS, getLocationStatus);
    yield takeEvery(GET_CITY_LIST_LITE, getCitiesListLite);
    yield takeEvery(GET_PREFIX_LIST, getPrefixList);
    yield takeEvery(GET_SUFFIX_LIST, getSuffixList);
    yield takeEvery(GET_MARITAL_STATUS_LIST, getMaritalStatusList);

    yield takeEvery(GET_SAMPLE_TYPES_LIST, getSampleTypesList);
    yield takeEvery(GET_SAMPLE_STATUS_LIST, getSampleStatusList);
    yield takeEvery(GET_BILLING_MODE_LIST, getBillingModeList);
    yield takeEvery(GET_PANEL_CODE_LIST, getPanelCodeList);
    yield takeEvery(GET_ACCOUNT_EXECUTIVE_LIST, getAccountExecutiveList);

    yield takeEvery(GET_EQUIPMENT_TYPE_LIST, getEquipmentTypeList);
    yield takeEvery(GET_TEST_PANEL_LIST, getTestPanelList);

    yield takeEvery(GET_SAMPLE_COLLECTION_DEVICE_LIST, getSampleCollectionDeviceList);
    yield takeEvery(GET_REPORT_TYPE_LIST, getReportTypesList);
    yield takeEvery(GET_TEST_LIST_LITE, getTestListLite);
    yield takeEvery(GET_EXPRESSIONS_LIST_LITE, getExpressionsListLite);
    yield takeEvery(GET_BIOMARKER_LIST, getBiomarkerList);
    yield takeEvery(GET_AGE_LIST, getAgeList);
    yield takeEvery(GET_ROLE_LIST, getRoleList);
    yield takeEvery(GET_SYSTEM_CONFIG, getSystemConfig)
    yield takeEvery(GET_SAMPLE_TYPES_WITH_COLLECTION_DEVICES, getSampleTypesWithCollectionDevices)
    yield takeEvery(GET_MODULE_PRIMARY_ATTACHMENT, getModulePrimaryAttachment)
}
